module.exports = __webpack_public_path__ + "static/media/cider-3-x@3x.8277acf2.png";